import { useState, useLocation, useMemo, useEffect, Player, FormatDate, ActivityDetailedSkeleton, Assignment, Header, SideNav, BreadCrumbs, decryptData, handleApiError, axios, useNavigate, useParams, PDFIcon, Video, Chevron, ReactModal, Form, PptIcon, UpArrow, Completed, CourseQuiz, Incorrect, View, Retry, ClockFill, ContentMenu, DOCIcon } from "../../UserImport";
import "./ActivityDetailed.css";


const QUIZ_DEFAULT_CUTOFF = 0;

const getNormalizedPercentage = (value) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? Math.round(numericValue) : null;
};

const extractQuizPayload = (responseData) => responseData?.Result || responseData?.result || null;

const getQuizQuestions = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.questions)) return payload.questions;
    if (Array.isArray(payload?.quizQuestions)) return payload.quizQuestions;
    if (Array.isArray(payload?.questionDetails)) return payload.questionDetails;
    return [];
};

const normalizeQuizQuestions = (questions = [], resetSelections = false) => {
    return questions.map((question) => ({
        ...question,
        selectedOption: resetSelections ? null : question?.selectedOption ?? null,
        wasMarkedCorrect: resetSelections ? null : question?.wasMarkedCorrect ?? null,
        options: Array.isArray(question?.options) ? question.options : []
    }));
};

const buildQuizSummary = (payload, questions = []) => {
    const summarySource = Array.isArray(payload) ? {} : (payload || {});
    const totalQuestions = questions.length;
    const answeredCount = questions.filter((question) => question?.selectedOption != null).length;
    const correctCount = questions.filter((question) => Number(question?.wasMarkedCorrect) === 1).length;
    const percentage = [
        summarySource?.scorePercentage,
        summarySource?.finalScorePercentage,
        summarySource?.percentage,
        summarySource?.finalPercentage,
        summarySource?.resultPercentage,
        summarySource?.score,
    ]
        .map(getNormalizedPercentage)
        .find((value) => value !== null) ??
        (totalQuestions > 0 && answeredCount > 0 ? Math.round((correctCount / totalQuestions) * 100) : null);

    const cutoff = [
        summarySource?.cutoffPercentage,
        summarySource?.cutOffPercentage,
        summarySource?.passPercentage,
        summarySource?.passingPercentage,
        summarySource?.minimumPercentage,
        summarySource?.qualifyingPercentage,
        summarySource?.passingScore,
    ]
        .map(getNormalizedPercentage)
        .find((value) => value !== null) ?? QUIZ_DEFAULT_CUTOFF;

    const explicitPassState = [summarySource?.isPassed, summarySource?.passed, summarySource?.isPass].find((value) => typeof value === "boolean");
    const isPassed = typeof explicitPassState === "boolean" ? explicitPassState : percentage !== null ? percentage >= cutoff : null;

    if (answeredCount === 0 && percentage === null) {
        return null;
    }

    return {
        percentage: percentage ?? 0,
        cutoff,
        correctCount,
        totalQuestions,
        answeredCount,
        isPassed,
    };
};


const ActivityDetailedView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    
    const getTechTalkId = () => {
        if (params.techTalkId) {
            return params.techTalkId;
        }
        const storedId = window.location.pathname.includes("techtalk") ? sessionStorage.getItem('_activityId') : null;
        return storedId;
    };

    const getCourseId = () => {
        if (params.courseId) {
            return params.courseId;
        }
        const storedId = window.location.pathname.includes("course") ? sessionStorage.getItem('_activityId') : null;
        return storedId;
    };

    const [activityInfo, setActivityInfo] = useState({
        details: null,
        activityHistory: null,
        activityHistoryId: window.location.pathname.includes("course") ? sessionStorage.getItem('_historyId') : window.location.pathname.includes("techtalk") ? sessionStorage.getItem('_historyId') : null,
        videoIndex: 0,
        playList: [],
        currentVideoSrc: null,
        activeModuleId: null,
        activityName: window.location.pathname.includes("course") ? "Course" : window.location.pathname.includes("techtalk") ? "TechTalk" : null,
        activityId: window.location.pathname.includes("course") ? (params.courseId || sessionStorage.getItem('_activityId')) : getTechTalkId(),
        currentContentId: null,
        response: null,
        MappingId: null,
        isLoding: true,
        allTechTalk: null,
        assignmentDetails: null
    });
    const [isReadMoreModal, setIsReadMoreModal] = useState({
        showModal: false,
        selectedItems: null
    });
    const [quiz, setQuiz] = useState({
        isLoding: true,
        quizData: null,
        choosenAns: [],
        correctAns: [],
        isReset: undefined,
        isSubmited: false,
        isSubmitting: false,
        summary: null,
        errorMessage: null,
    });

    useEffect(() => {
        const storedActivityId = sessionStorage.getItem('_activityId');
        const normalizedPath = location.pathname.replace(/\/$/, '');
        const isGenericCoursePath = normalizedPath === '/lms/course';
        const isGenericTechTalkPath = normalizedPath === '/lms/techtalk';

        if (isGenericCoursePath && storedActivityId) {
            navigate(`/lms/course/${storedActivityId}`, { replace: true });
            return;
        }

        if (isGenericTechTalkPath && storedActivityId) {
            navigate(`/lms/techtalk/${storedActivityId}`, { replace: true });
            return;
        }
    }, [location.pathname, navigate]);

    let parsedObject;
    const data = localStorage.getItem("userData");
    data ? (parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY)) : navigate("/error/statusCode=400");

    const StartTechTalk = async (storeCourseId) => {
        const url = `${process.env.REACT_APP_API_URL_DOTNET}/TechTalk/startTechTalk?userId=${parsedObject["decoded"].Id}`;
        const headers = {
            Authorization: `Bearer ${parsedObject["token"]}`,
        };
        const formData = new FormData();
        formData.append("techTalkId", storeCourseId);
        try {
            const response = await axios.post(url, formData, { headers });

            if (response.data.Success === 201 || response.data.success === 201) {
                const historyId = response.data.Result || response.data.result;
                sessionStorage.setItem("_historyId", historyId);
                sessionStorage.setItem("_activityId", storeCourseId);
                window.location.reload();
            } else if (response.status >= 200 && response.status < 300) {
                const historyId = response.data.Result || response.data.result;
                if (historyId) {
                    sessionStorage.setItem("_historyId", historyId);
                    sessionStorage.setItem("_activityId", storeCourseId);
                    window.location.reload();
                } else {
                    console.error('Unexpected response format from StartTechTalk:', response.data);
                    throw new Error(`No history ID in response: ${JSON.stringify(response.data)}`);
                }
            } else {
                console.error('Unexpected response format from StartTechTalk:', response.data);
                throw new Error(`Unexpected response format: ${JSON.stringify(response.data)}`);
            }
        } catch (error) {
            console.error('Error in StartTechTalk:', error);
            const statusCode = error.response ? error.response.status : null;
            if (statusCode === 500) {
                console.error('StartTechTalk error 500');
                navigate('/lms/dashboard', { replace: true });
            } else {
                handleApiError(error.response, navigate);
            }
        }
    };

    const fetchData = async (forcedActivityHistoryId = null) => {
        if (!activityInfo.activityId) {
            navigate('/lms/dashboard', { replace: true });
            return;
        }

        const effectiveActivityHistoryId = forcedActivityHistoryId || activityInfo.activityHistoryId;

        if (activityInfo.activityName === "TechTalk" && !effectiveActivityHistoryId) {
            await StartTechTalk(activityInfo.activityId);
            return;
        }

        const url = `${process.env.REACT_APP_API_URL_DOTNET}/Activity/userActivityDetails`;
        const body = {
            userId: parsedObject["decoded"].Id,
            activityName: activityInfo.activityName.toLocaleLowerCase(),
            activityId: activityInfo.activityId
        };
        
        if (effectiveActivityHistoryId) {
            body.activityHistoryId = effectiveActivityHistoryId;
        }
        
        const headers = {
            Authorization: `Bearer ${parsedObject["token"]}`,
        };
        try {
            const response = await axios.post(url, body, { headers });

            if (response.status >= 200 && response.status < 300) {               
                const resultData = response.data.Result || response.data.result;
                
                if (!resultData) {
                    navigate('/lms/dashboard', { replace: true });
                    return;
                }

                if (activityInfo.activityName == "Course") {
                    try {
                        const courseInfo = resultData.courseInfo;
                        const activityHistory = resultData.activityHistory;
                        const courseActivityHistories = activityHistory?.courseActivityHistories;

                        if (!courseInfo || !courseInfo.modules) {
                            navigate(`/lms/course-detail/${activityInfo.activityId}`, { replace: true });
                            return;
                        }

                        const activityHistoryId = courseActivityHistories?.activityHistoryId;
                        const emptyGuid = "00000000-0000-0000-0000-000000000000";
                        const isEnrolled = activityHistoryId && activityHistoryId !== emptyGuid && activityHistoryId !== "";
                        
                        if (!isEnrolled) {
                            navigate(`/lms/course-detail/${activityInfo.activityId}`, { replace: true });
                            return;
                        }
                        
                        const { modules } = courseInfo;
                        const sortedModules = modules.sort((a, b) => a.orderNumber - b.orderNumber);

                        const playList = sortedModules.flatMap((module) => {
                            const sortedModuleContent = (module.moduleContent || []).sort((a, b) => a.orderNumber - b.orderNumber);
                            return sortedModuleContent.flatMap((content) => {
                                const sortedContentAttachment = (content.contentAttachment || []).sort((a, b) => a.orderNumber - b.orderNumber);
                                return sortedContentAttachment.map((contentAttachment) => {
                                    const courseActivityHistories = activityHistory?.courseActivityHistories || {};
                                    const contentDetails = courseActivityHistories.contentDetails || [];
                                    const matchingDetail = contentDetails.find((detail) => detail.moduleInfo && detail.moduleInfo.some((info) => info.contentId === contentAttachment.id));
                                    let SeekDuration = "";
                                    let isCompleted = false;
                                    let moduleMappingId = undefined

                                    if (matchingDetail && matchingDetail.moduleInfo) {
                                        const contentDetail = matchingDetail.moduleInfo.find((info) => info.contentId === contentAttachment.id);
                                        if (contentDetail) {
                                            SeekDuration = contentDetail.seekDuration || "";
                                            isCompleted = contentDetail.completionStatus || false;
                                            moduleMappingId = contentDetail.moduleMappingId || undefined
                                        }
                                    }
                                    return {
                                        contentTitle: contentAttachment.name,
                                        path: contentAttachment.fullPath  ? (contentAttachment.fullPath.includes(".pptx") || contentAttachment.fullPath.includes(".ppt") ? `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(contentAttachment.fullPath)}&wdOrigin=BROWSELINK` : contentAttachment.fullPath) : null,
                                        isQuiz: contentAttachment.isQuiz || contentAttachment.name?.toLowerCase().endsWith('.csv'),
                                        moduleId: module.id,
                                        contentId: contentAttachment.id,
                                        SeekDuration,
                                        isCompleted,
                                        moduleMappingId
                                    };
                                });
                            });
                        }).filter((item) => item !== null);

                        setActivityInfo((prevState) => ({
                            ...prevState,
                            details: courseInfo,
                            activityHistory: resultData.activityHistory.courseActivityHistories,
                            playList: playList,
                            isLoding: false,
                        }));
                    } catch (courseError) {
                        throw courseError;
                    }
                } else {
                    const techTalkActivityHistories = resultData.activityHistory?.techTalkActivityHistories;
                    const activityHistoryId = techTalkActivityHistories?.activityHistoryId;
                    const emptyGuid = "00000000-0000-0000-0000-000000000000";
                    const isEnrolled = activityHistoryId && activityHistoryId !== emptyGuid && activityHistoryId !== "";
                    
                    if (!isEnrolled) {
                        navigate(`/lms/techtalk/${activityInfo.activityId}`, { replace: true });
                        return;
                    }

                    if (!resultData.techtalkInfo || !resultData.techtalkInfo.videoDetails) {
                        navigate(`/lms/techtalk/${activityInfo.activityId}`, { replace: true });
                        return;
                    }
                    
                    let techtalkPlaylist = resultData.techtalkInfo.videoDetails.map((video) => {
                        let activityHistory = resultData.activityHistory;
                        let historyDetails = activityHistory.techTalkActivityHistories?.contentDetails || [];
                        let SeekDuration = null;
                        let isCompleted = false;

                        if (historyDetails.length > 0) {
                            let contentDetail = historyDetails.find((detail) => detail?.videoId === video.videoId);
                            if (contentDetail) {
                                SeekDuration = contentDetail.seekDuration || "";
                                isCompleted = contentDetail.completionStatus || false;
                            }
                        }

                        return {
                            contentId: video.videoId,
                            contentTitle: video.videoName,
                            path: video.filePath.includes(".pptx") || video.filePath.includes(".ppt") ? `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(video.filePath)}&wdOrigin=BROWSELINK` : video.filePath,
                            SeekDuration: SeekDuration,
                            isCompleted: isCompleted,
                        };
                    });
                    
                    setActivityInfo((prevState) => ({
                        ...prevState,
                        details: resultData.techtalkInfo || {},
                        activityHistory: resultData.activityHistory?.techTalkActivityHistories || [],
                        playList: techtalkPlaylist,
                        isLoding: false
                    }));
                }

            } else {
                navigate('/lms/dashboard', { replace: true });
            }
        } catch (error) {
            const statusCode = error.response ? error.response.status : null;

            if (activityInfo.activityName === "Course") {
                navigate(`/lms/course-detail/${activityInfo.activityId}`, { replace: true });
                return;
            }

            if (statusCode === 404 || statusCode === 400) {
                navigate('/lms/dashboard', { replace: true });
                return;
            }

            if (statusCode === 500) {
                navigate('/lms/dashboard', { replace: true });
                return;
            }
            
            navigate('/lms/dashboard', { replace: true });
        }
    };

    useEffect(() => {
        fetchData();
        setQuiz({
            ...quiz,
            choosenAns: []
        });
    }, []);
    
    const removeSpecialCharacters = (filename, length = undefined) => {
        const fileExtension = filename.split('.').pop().toLowerCase();
        let icon;
        switch (fileExtension) {
            case "mp4":
                icon = <Video />
                break;
            case "pptx":
                icon = <PptIcon />
                break;
            case "pdf":
                icon = <PDFIcon />
                break;
            case "csv":
                icon = <CourseQuiz />
                break;
            case "docx":
                icon = <DOCIcon />
                break;
            default:
                break;
        }
        const fileNameWithoutExtension = filename.replace(/\.[^/.]+$/, "");
        let cleanFileName = fileNameWithoutExtension.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/gi, ' ');
        if (length) {
            if (cleanFileName.length > length) {
                cleanFileName = cleanFileName.slice(0, length) + '...';
            }
        }
        return { cleanFileName, icon };
    };

    const getAllTechTalk = async () => {
        let url = `${process.env.REACT_APP_API_URL_DOTNET}/TechTalk/getAll?isArchived=1`;
        const headers = {
            Authorization: `Bearer ${parsedObject["token"]}`,
        };
        try {
            const response = await axios.get(url, { headers });
            if (response.data.success == 200) {
                setActivityInfo({
                    ...activityInfo,
                    isloading: false,
                    allTechTalk: response.data.result,
                });
            } else {
                throw new Error(`Unexpected response status: ${response.status}`);
            }
        } catch (error) {
            const statusCode = error.response ? error.response.status : null;
            handleApiError(statusCode, navigate);
        }
    };

    const handleQuizAns = (optionId, quizId, name) => {
        let ans = { optionId: optionId, questionId: quizId, optionName: name };
        setQuiz((prevState) => {
            const existingAnswer = prevState.choosenAns.find((answer) => answer.questionId === quizId);
            if (existingAnswer) {
                const updatedChoosenAns = prevState.choosenAns.map((answer) => {
                    if (answer.questionId === quizId) {
                        return { ...answer, optionId: optionId, optionName: name };
                    } else {
                        return answer;
                    }
                });
                return {
                    ...prevState,
                    choosenAns: updatedChoosenAns
                };
            } else {
                let updatedChoosenAns = prevState.choosenAns.filter(x => x.questionId != ans.questionId);
                return {
                    ...prevState,
                    choosenAns: [...updatedChoosenAns, ans]
                };
            }
        });
    };

    const handleQuizData = async (moduleId, options = {}) => {
        const { resetSelections = false } = options;
        const targetModuleId = moduleId || activityInfo.activeModuleId;
        if (!targetModuleId) {
            setQuiz((prevState) => ({
                ...prevState,
                isLoding: false,
                quizData: [],
                summary: null,
                errorMessage: null,
                isSubmitting: false,
            }));
            return;
        }

        setQuiz((prevState) => ({
            ...prevState,
            isLoding: true,
            errorMessage: null,
            isSubmitting: false,
            ...(resetSelections ? {
                choosenAns: [],
                correctAns: [],
                isSubmited: false,
                summary: null,
            } : {}),
        }));

        const url = `${process.env.REACT_APP_API_URL_DOTNET}/Activity/getModuleQuiz?ModuleId=${targetModuleId}`;
        const headers = {
            Authorization: `Bearer ${parsedObject["token"]}`,
        };
        try {
            const response = await axios.get(url, { headers });
            if (response.data.success == 200) {
                const quizPayload = extractQuizPayload(response.data);
                const questions = normalizeQuizQuestions(getQuizQuestions(quizPayload), resetSelections);
                const summary = resetSelections ? null : buildQuizSummary(quizPayload, questions);

                setQuiz((prevState) => ({
                    ...prevState,
                    isLoding: false,
                    quizData: questions,
                    isReset: undefined,
                    choosenAns: [],
                    correctAns: [],
                    isSubmited: resetSelections ? false : questions.some((question) => question.selectedOption != null),
                    isSubmitting: false,
                    summary,
                    errorMessage: null,
                }));
            } else {
                throw new Error(`Unexpected response status: ${response.status}`);
            }
        } catch (error) {
            console.error("Failed to fetch quiz data", error);
            setQuiz((prevState) => ({
                ...prevState,
                isLoding: false,
                isSubmitting: false,
                errorMessage: "We couldn't load this quiz right now. Please try again in a moment.",
            }));
            if (error?.response || error?.request) {
                handleApiError(error, navigate);
            }
        }
    };

    const handleQuizScore = async (moduleId) => {
        const targetModuleId = moduleId || activityInfo.activeModuleId;
        if (!targetModuleId) return;

        setQuiz((prevState) => ({
            ...prevState,
            isLoding: true,
            errorMessage: null,
            isSubmitting: false,
            choosenAns: [],
            correctAns: [],
        }));

        const url = `${process.env.REACT_APP_API_URL_DOTNET}/Activity/getModuleQuizScore?ModuleId=${targetModuleId}`;
        const headers = {
            Authorization: `Bearer ${parsedObject["token"]}`,
        };
        try {
            const response = await axios.get(url, { headers });
            if (response.data.success == 200) {
                const scoreData = response.data.Result || response.data.result;
                const totalQuestions = scoreData?.totalQuestions ?? scoreData?.TotalQuestions ?? 0;
                const correctCount = scoreData?.correctQuestions ?? scoreData?.CorrectQuestions ?? 0;
                const cutoff = getNormalizedPercentage(scoreData?.cutOffPercentage ?? scoreData?.CutOffPercentage) ?? QUIZ_DEFAULT_CUTOFF;
                const percentage = totalQuestions > 0 ? Math.round((correctCount / totalQuestions) * 100) : 0;
                const isPassed = percentage >= cutoff;

                setQuiz((prevState) => ({
                    ...prevState,
                    isLoding: false,
                    quizData: [],
                    isReset: undefined,
                    choosenAns: [],
                    correctAns: [],
                    isSubmited: true,
                    isSubmitting: false,
                    summary: {
                        percentage,
                        cutoff,
                        correctCount,
                        totalQuestions,
                        answeredCount: totalQuestions,
                        isPassed,
                    },
                    errorMessage: null,
                }));
            } else {
                throw new Error(`Unexpected response status: ${response.status}`);
            }
        } catch (error) {
            console.error("Failed to fetch quiz score", error);
            const statusCode = error?.response?.status;
            if (statusCode === 404) {
                await handleQuizData(targetModuleId);
                return;
            }
            setQuiz((prevState) => ({
                ...prevState,
                isLoding: false,
                isSubmitting: false,
                errorMessage: "We couldn't load the quiz score right now. Please try again in a moment.",
            }));
            if (error?.response || error?.request) {
                handleApiError(error, navigate);
            }
        }
    };

    const handleQuizRetry = async () => {
        await handleQuizData(activityInfo.activeModuleId, { resetSelections: true });
    };

    const submitQuiz = async () => {
        setQuiz((prevState) => ({
            ...prevState,
            isSubmitting: true,
            errorMessage: null,
        }));
        const url = `${process.env.REACT_APP_API_URL_DOTNET}/Activity/submitQuiz`;
        const headers = {
            Authorization: `Bearer ${parsedObject["token"]}`,
        };
        const body = {
            ChoosenAns: quiz.choosenAns,
            courseId: activityInfo.activityId,
            moduleId: activityInfo.playList.find(item => item.contentId == activityInfo.currentContentId)?.moduleId || activityInfo.activeModuleId,
            contentAttachmentId: activityInfo.currentContentId,
            moduleActivityHistoryId: activityInfo.activityHistoryId,
        }
        try {
            const response = await axios.post(url, body, { headers });
            if (response.data.success == 200) {
                setQuiz((prevState) => ({
                    ...prevState,
                    correctAns: response.data.result,
                    isSubmited: true,
                    isSubmitting: false,
                    errorMessage: null,
                }));
                await fetchData();
                await handleQuizScore(activityInfo.activeModuleId);
            } else {
                throw new Error(`Unexpected response status: ${response.status}`);
            }

        } catch (error) {
            console.error("Failed to submit quiz", error);
            setQuiz((prevState) => ({
                ...prevState,
                isSubmitting: false,
                errorMessage: "We couldn't submit your quiz right now. Please try again.",
            }));
            if (error?.response || error?.request) {
                handleApiError(error, navigate);
            }
        }
    };

    const selectVideo = (index, moduleId = undefined, mappingId = undefined, videoId = undefined, historyId = undefined, name = undefined) => {
        const isCsvQuiz = typeof name === "string" && name.toLowerCase().includes(".csv");
        if (moduleId != undefined && !isCsvQuiz) {
            let contentLink = activityInfo.playList.filter(x => x.moduleId == moduleId)[--index];
            setActivityInfo((prevState) => ({
                ...prevState,
                videoIndex: index,
                activeModuleId: moduleId,
                currentVideoSrc: contentLink,
                currentContentId: contentLink.contentId,
                activityHistoryId: historyId,
                MappingId: mappingId
            }))
        } else if (isCsvQuiz) {
            let contentLink = activityInfo.playList.filter(x => x.moduleId == moduleId)[--index];
            setActivityInfo((prevState) => ({
                ...prevState,
                currentVideoSrc: contentLink,
                currentContentId: contentLink.contentId,
                MappingId: mappingId,
                activityHistoryId: historyId,
                activeModuleId: contentLink.moduleId
            }))
            setQuiz((prevState) => ({
                ...prevState,
                isLoding: true,
                quizData: null,
                choosenAns: [],
                correctAns: [],
                isReset: undefined,
                isSubmited: false,
                isSubmitting: false,
                summary: null,
                errorMessage: null,
            }));
            if (contentLink.isCompleted) {
                handleQuizScore(contentLink.moduleId);
            } else {
                handleQuizData(contentLink.moduleId);
            }
        } else {
            let contentLink = activityInfo.playList[index];
            setActivityInfo((prevState) => ({
                ...prevState,
                videoIndex: index,
                currentContentId: videoId,
                MappingId: mappingId,
                activityHistoryId: historyId,
                currentVideoSrc: contentLink
            }));
        }
    };


    const handleModuleChange = (id) => {
        setActivityInfo((prevState) => ({
            ...prevState,
            activeModuleId: prevState.activeModuleId == id ? null : id,
        }));
    }

    const handlePlay = () => {
        const video = document.querySelector("video");
        if (video.requestFullscreen) {
            //video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen(); // Safari
        } else if (video.msRequestFullscreen) {
            video.msRequestFullscreen(); // IE/Edge
        }
    };

    const markContentComplete = (contentId) => {
        const SeekDuration = document.querySelector("#contentPlayer");
        let IsCompleted = SeekDuration?.currentTime == SeekDuration?.duration
        let markComplete = activityInfo.playList.find(x => x.contentId == contentId);
        if (markComplete)
            markComplete.isCompleted = IsCompleted;
        return;
    }
    const checkLockedContent = (content, index, activityType) => {
        if (!content) return false;
        const contentId = activityType.toLowerCase() === "course" ? content.id : content.videoId;
        const contentIndex = activityInfo.playList.findIndex(x => x.contentId === contentId);
        if (contentIndex === -1) return false;
        const prevContentIndex = index >= 0 ? contentIndex - 1 : -1;
        const prevContentData = prevContentIndex >= 0 ? activityInfo.playList[prevContentIndex] : null;
        const isContentLocked = activityInfo.playList[contentIndex]?.isCompleted;
        const isPrevContentLocked = prevContentData ? prevContentData.isCompleted : true;
        if (!isContentLocked && !isPrevContentLocked) {
            return false;
        }
        return true;
    }
    const handleReadMore = (item) => {
        setIsReadMoreModal((prevState) => ({
            ...prevState,
            selectedItems: item,
            showModal: true
        }));
    };

    const controlPlayBack = async (isDocMarkedCompleted = false) => {
        const SeekDuration = document.querySelector("#contentPlayer");
        let isCompleted = false;
        if (!isDocMarkedCompleted) {
            isCompleted = SeekDuration?.currentTime == SeekDuration.duration
            markContentComplete(activityInfo.currentContentId);
        }
        setActivityInfo({
            ...activityInfo,
            response: null
        })
        const url = `${process.env.REACT_APP_API_URL_DOTNET}/Activity/controlVideoSeek`;
        const headers = {
            Authorization: `Bearer ${parsedObject["token"]}`,
        };
        const body = {
            "userId": parsedObject["decoded"].Id,
            "activityName": activityInfo.activityName,
            "ModuleId": activityInfo.playList.find(item => item.contentId == activityInfo.currentContentId)?.moduleId || activityInfo.activeModuleId,
            "ContentMappingId": activityInfo.playList.find(mappingId => mappingId.contentId == activityInfo.currentContentId)?.moduleMappingId || "00000000-0000-0000-0000-000000000000",
            "ActivityHistoryId": activityInfo.activityHistoryId,
            "SeekDuration": SeekDuration?.currentTime.toString() || "",
            "IsCompleted": isCompleted || isDocMarkedCompleted,
            "ContentId": activityInfo.currentContentId
        }
        const response = await axios.post(url, body, { headers });
        if (response.data.success == 200) {
            setActivityInfo((prevState) => ({
                ...prevState,
                videoIndex: ++prevState.videoIndex,
                response: response.data.result
            }));
            fetchData();
        }
    }

    const shouldApplyContentViewerBg = (currentVideoSrc) => {
        if (currentVideoSrc == null) return 'content-viewer-bg';
        if (currentVideoSrc && !currentVideoSrc?.path?.includes(".csv") && !currentVideoSrc?.path?.includes(".pdf") && !currentVideoSrc?.path?.includes(".pptx") && !currentVideoSrc?.path?.includes(".ppt")) {
            return 'content-viewer-bg';
        }
        return '';
    }

    const disabledItems = (attachmentId, currentIndex, moduleId, moduleIndex = undefined) => {
        if (moduleIndex == undefined) { //tech talk disabled items 
            let currentPlaylistItem = activityInfo.playList.find(x => x.contentId === attachmentId);
            // If the current item is completed, do not disable
            if (currentPlaylistItem && currentPlaylistItem.isCompleted) {
                return '';
            }
            // If it's the first item in the playlist, do not disable
            if (activityInfo.playList[0].contentId == attachmentId) return '';

            // Check if the previous module is completed
            let lastModuleIndex = activityInfo.playList.findIndex(x => x.moduleId == moduleId) - 1
            if (currentIndex === 0 && lastModuleIndex >= 0 && activityInfo.playList[lastModuleIndex].isCompleted) return '';

            // Check if the previous item in the same module is completed
            let prevIndex = currentIndex - 1;
            if (prevIndex >= 0 && activityInfo.playList[prevIndex].isCompleted && activityInfo.playList[prevIndex].moduleId === moduleId) {
                return '';
            }
            // If none of the above conditions are met, disable the item
            return 'disable-items';
        } else {    //course disabled Items 
            if (currentIndex === 0 && moduleIndex === 0) return "";
            // If the current item is completed, do not disable
            if (activityInfo.playList.find(x => x.contentId === attachmentId).isCompleted) {
                return '';
            } else {
                let moduleData = activityInfo.playList.filter(x => x.moduleId === moduleId);
                let previousItemIndex = activityInfo.playList.findIndex(x => x.contentId === attachmentId) - 1
                // Check if the previous item in the module is completed
                if (moduleData[--currentIndex]?.isCompleted || (previousItemIndex >= 0 && activityInfo.playList[previousItemIndex]?.isCompleted)) {
                    return ''
                } else {
                    return 'disable-items';

                }
            }
        }
    };

    useEffect(() => {
    }, [activityInfo.playList])
    

    const handleAssignmentClick = () => {
        const isAllcompleted = activityInfo.playList.find(x => x.isCompleted == false);
        if (isAllcompleted) {
            return true;
        }
        return true;
    }
    const selectAssignment = (assignmentSrc) => {
        setActivityInfo({
            ...activityInfo,
            currentVideoSrc: assignmentSrc,
            assignmentDetails: activityInfo.details.assignments[0]
        })
    }
    const aboutText = activityInfo?.details?.about || (activityInfo?.details?.instructorList[0]?.about || '');
    const displayAbout = aboutText.length > 50;
    const quizSelections = useMemo(() => {
        return quiz.choosenAns.reduce((selectionMap, answer) => {
            selectionMap[answer.questionId] = answer.optionId;
            return selectionMap;
        }, {});
    }, [quiz.choosenAns]);
    const quizHasStoredAnswers = useMemo(() => {
        return Array.isArray(quiz.quizData) && quiz.quizData.some((question) => question.selectedOption != null);
    }, [quiz.quizData]);
    const isQuizReviewMode = useMemo(() => {
        return Boolean(quiz.summary && (quiz.isSubmited || quizHasStoredAnswers));
    }, [quiz.summary, quiz.isSubmited, quizHasStoredAnswers]);
    const canRetryQuiz = isQuizReviewMode && quiz.summary?.isPassed === false;
    const canSubmitQuiz = Array.isArray(quiz.quizData) && quiz.quizData.length > 0 && quiz.choosenAns.length === quiz.quizData.length && !quiz.isSubmitting;

    useEffect(() => {
        const handleRouteChange = () => {
            sessionStorage.removeItem("_historyId");
            sessionStorage.removeItem("_activityId");
        };
        return () => {
            handleRouteChange();
        };
    }, [location.pathname]);

    useEffect(() => {
        if (activityInfo.activityName == "TechTalk" && activityInfo.playList.length !== 0 && activityInfo.playList[activityInfo.playList.length - 1].isCompleted) {
            getAllTechTalk();
        }
    }, [activityInfo.playList[activityInfo.playList.length - 1]?.isCompleted])

    return (
        <>
            <div>
                <Header />
                <SideNav />
            </div>
            <div className={`container-fluid mt-5  ${activityInfo.activityName.toLocaleLowerCase() == "techtalk" ? "primary-bg" : "activity-parent-wrapper-bg "}`}>
                <div className="row">
                    <div className="col-12">
                        <div className="ms-5 mt-4 mb-2 activityCrumb">
                            <BreadCrumbs />
                        </div>
                    </div>
                </div>
            </div>
            {activityInfo.isLoding ? <ActivityDetailedSkeleton activityType={activityInfo.activityName} /> :
                <div className="container-fluid activity-parent-wrapper activity-parent-wrapper-bg">
                    <div className={`d-flex flex-row justify-content-center  activity-wrapper mb-2 pb-2 gap-4 ${activityInfo.activityName.toLocaleLowerCase() == "techtalk" && "tech-talk-bg"} `}>
                        <div className="col-8 d-flex gap-3" >
                            <div className="col-2">
                                <img src={activityInfo.details?.thumbnailUri} alt="thumbnail" width={144} height={144} style={{borderRadius: "9px"}} />
                            </div>
                            <div className="col-8 activity-content">
                                {activityInfo.details?.gradeType !== undefined && (
                                    <div className="activity-grade-wrapper">
                                        <ul typeof="disk" className="d-flex mt-2 mb-1 ps-0">
                                            <li>{activityInfo?.details?.gradeType}</li>
                                            <li className="mx-4">{activityInfo?.details?.levelName}</li>
                                        </ul>
                                    </div>
                                )}
                                <div className="actity-title course-info-read-more-title" title={activityInfo.details?.title}>
                                    <h5>{activityInfo.details?.title?.length > 50 ?
                                        <>{activityInfo.details?.title.slice(0, 50)}<span> ...</span></> :
                                        activityInfo.details?.title}</h5>
                                </div>
                                <div className={`${activityInfo.activityName.toLocaleLowerCase() == "techtalk" ? "tt course-info-read-more-title" : "activity-description course-info-read-more-title"}`}>
                                    <p>{activityInfo.details?.description?.length > 200 ?
                                        <>{activityInfo.details?.description.slice(0, 100)}<span className="text-primary pointer" onClick={() => { handleReadMore(activityInfo.details) }}> ...Read More</span></> :
                                        activityInfo.details?.description}
                                    </p>
                                </div>
                                <div className={`activity-tags d-flex ${activityInfo.details?.gradeType == undefined && "mt-3"}`}>
                                    {
                                        activityInfo.details.tags.length > 6 ?
                                            <>
                                                {activityInfo?.details?.tags?.slice(0, 6).map((tagName, index) => (
                                                    <span key={index}>{tagName?.techName}</span>
                                                ))}
                                                <span title={activityInfo?.details?.tags?.slice(6).map((tagName) => (" " + tagName?.techName))}>
                                                    +{activityInfo?.details?.tags?.slice(6).length} </span>
                                            </> : activityInfo?.details?.tags?.map((tagName, index) => (
                                                <span key={index}>{tagName?.techName}</span>
                                            ))
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={`col-4 mentor-card-wrapper p-3 ${activityInfo.activityName.toLocaleLowerCase() == "techtalk" && "tech-talk-mentor-card"} `}>
                            <div className="mentor-info-wrapper d-flex gap-3">
                                <div className="mentor-img-wrapper">
                                    {
                                        activityInfo?.details?.imageUrl ?
                                            <img
                                                src={activityInfo?.details?.imageUrl}
                                                alt="thumbnail"
                                            /> : activityInfo?.details?.instructorName?.split(" ").slice(0).toString().slice(0, 1) + activityInfo?.details?.instructorName?.split(" ").slice(1).toString().slice(0, 1) ||
                                            activityInfo?.details?.instructorList[0]?.firstName.slice(0, 1) +
                                            activityInfo?.details?.instructorList[0]?.lastName.slice(0, 1)
                                    }
                                </div>
                                <div className="mentor-name-wrapper">
                                    <p className="my-0">
                                        {activityInfo?.details?.instructorName ||
                                            activityInfo?.details?.instructorList[0]?.firstName +
                                            " " +
                                            activityInfo?.details?.instructorList[0]?.lastName}
                                    </p>
                                    <p className="my-0">
                                        {activityInfo?.details?.designation || activityInfo?.details?.instructorList[0]?.designation}
                                    </p>
                                </div>
                            </div>
                            {displayAbout ? <div title={aboutText}>{aboutText.slice(0, 100)}<span>...</span></div> : <div title={aboutText}> {aboutText}</div>}
                        </div>
                    </div >
                    {
                        activityInfo.activityName.toLocaleLowerCase() == "techtalk" && (<div className="row ms-5 duration-wrapper">
                            <p className="mb-0">
                                Duration
                            </p>
                            <span>
                            {activityInfo.details.totalVideosLength?.replace(
                                /^\s*(?:(\d+)\s*days?)?\s*(\d+)?\s*(?:hrs?|hours?)?\s*(\d+)?\s*(?:mins?|minutes?)?\s*$/i,
                                (_, d = 0, h = 0, m = 0) => {
                                const totalHours = d ? Number(d) * 24 + Number(h) : Number(h);
                                return `${totalHours} hr(s) ${m} min(s)`;
                                }
                            )}
                            </span>
                        </div>)
                    }

                    <div className="row d-flex ms-5 flex-row content-wrapper p-2 mb-3 dp-scroll" >
                        <div className={`col-8 p-0 content-viewer ${shouldApplyContentViewerBg(activityInfo.currentVideoSrc) ? 'content-viewer-bg' : ""} ${isQuizReviewMode ? "quiz-content-viewer-review" : ""}`}>
                            {activityInfo.currentVideoSrc && !activityInfo.currentVideoSrc?.isQuiz ?
                                activityInfo.currentVideoSrc == "assignment" ?
                                    <Assignment assignmentDetails={activityInfo} /> :
                                    <Player
                                        poster={"activityInfo.details?.thumbnailUri"}
                                        activityInfo={activityInfo}
                                        onPlay={() => { handlePlay() }}
                                        onEnd={() => { controlPlayBack() }}
                                        onPause={() => { controlPlayBack() }}
                                        onDocMarkCompleted={() => { controlPlayBack(true) }}
                                    /> : activityInfo.currentVideoSrc && activityInfo.currentVideoSrc.isQuiz ?
                                (<div className={`col-8 p-0 quiz-wrapper ${isQuizReviewMode ? "quiz-wrapper-review" : ""}`}>
                                    {quiz.errorMessage && (
                                        <div className="quiz-inline-feedback quiz-inline-feedback-error mb-3">
                                            {quiz.errorMessage}
                                        </div>
                                    )}
                                    {isQuizReviewMode && quiz.summary && (
                                        <div className={`quiz-review-state ${quiz.summary.isPassed ? "quiz-review-passed" : "quiz-review-failed"}`}>
                                            {/* Top row: heading + score circle */}
                                            <div className="quiz-rev-top">
                                                <div className="quiz-rev-title">
                                                    <h5>Quiz Result</h5>
                                                    <p>You answered {quiz.summary.correctCount} of {quiz.summary.totalQuestions} questions correctly.</p>
                                                </div>
                                                <div className="quiz-rev-circle">
                                                    <span className="quiz-rev-circle-val">{quiz.summary.percentage}%</span>
                                                </div>
                                            </div>

                                            {/* Congratulations banner */}
                                            {quiz.summary.isPassed && (
                                                <div className="quiz-rev-congrats">
                                                    <Completed />
                                                    <span>Congratulations! You have successfully passed the quiz.</span>
                                                </div>
                                            )}

                                            {!quiz.summary.isPassed && (
                                                <div className="quiz-rev-failed">
                                                    <Incorrect />
                                                    <span>Unfortunately, you did not pass the quiz. Please try again.</span>
                                                </div>
                                            )}

                                            {/* Correct / Incorrect progress bar */}
                                            <div className="quiz-rev-bar-section">
                                                <div className="quiz-rev-bar">
                                                    <div className="quiz-rev-bar-correct" style={{ width: `${(quiz.summary.correctCount / quiz.summary.totalQuestions) * 100}%` }}></div>
                                                    <div className="quiz-rev-bar-wrong" style={{ width: `${((quiz.summary.totalQuestions - quiz.summary.correctCount) / quiz.summary.totalQuestions) * 100}%` }}></div>
                                                </div>
                                                <div className="quiz-rev-bar-legend">
                                                    <span className="quiz-rev-legend-item"><Completed />&nbsp;Correct: {quiz.summary.correctCount}</span>
                                                    <span className="quiz-rev-legend-item"><Incorrect />&nbsp;Incorrect: {quiz.summary.totalQuestions - quiz.summary.correctCount}</span>
                                                </div>
                                            </div>

                                            {/* Stats row */}
                                            <div className="quiz-rev-stats">
                                                <div className="quiz-rev-stat">
                                                    <span className="quiz-rev-stat-label">Score</span>
                                                    <strong className="quiz-rev-stat-value">{quiz.summary.percentage}%</strong>
                                                </div>
                                                <div className="quiz-rev-stat">
                                                    <span className="quiz-rev-stat-label">Cutoff</span>
                                                    <strong className="quiz-rev-stat-value">{quiz.summary.cutoff}%</strong>
                                                </div>
                                                <div className="quiz-rev-stat">
                                                    <span className="quiz-rev-stat-label">Status</span>
                                                    <strong className={`quiz-rev-stat-value ${quiz.summary.isPassed ? "quiz-rev-status-pass" : "quiz-rev-status-fail"}`}>
                                                        {quiz.summary.isPassed ? "Passed" : "Failed"}
                                                    </strong>
                                                </div>
                                                <div className="quiz-rev-stat">
                                                    <span className="quiz-rev-stat-label">Questions</span>
                                                    <strong className="quiz-rev-stat-value">{quiz.summary.totalQuestions}</strong>
                                                </div>
                                            </div>

                                            {/* Retry */}
                                            <div className="quiz-rev-retry">
                                                <button className="btn retry-btn quiz-summary-retry" onClick={handleQuizRetry} disabled={quiz.isLoding || quiz.isSubmitting}>
                                                    <Retry />
                                                    <span>Retry Quiz</span>
                                                </button>
                                            </div>

                                            {/* Footer note */}
                                            <div className="quiz-rev-footer">
                                                <p>
                                                   Latest Attempt Score will be considered for evaluation.
                                                   </p>
                                            </div>
                                        </div>
                                    )}
                                    {
                                        !isQuizReviewMode && quiz.isLoding == false && quiz.quizData && quiz.quizData.length > 0 ? quiz.quizData.map((quizinfo, index) => {
                                            const selectedOptionId = quizSelections[quizinfo.questionId] ?? quizinfo.selectedOption ?? null;
                                            return (
                                            <div key={quizinfo.questionId}>
                                                <h5 className="activity-quiz">{index + 1}. &nbsp;{quizinfo.questionText}</h5>

                                                {quizinfo.options.map((option, optionIndex) => (
                                                    <div key={optionIndex} className="option-container">
                                                        <input type="radio" id={option.optionId} name={`quiz_${index}`} onChange={() => {
                                                            handleQuizAns(option.optionId, quizinfo.questionId, option.optionText)
                                                        }} checked={selectedOptionId === option.optionId} disabled={isQuizReviewMode || quiz.isSubmitting} /> &nbsp;
                                                        <label htmlFor={option.optionId}>{option.optionText}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        )}) : !isQuizReviewMode && quiz.isLoding == false && (
                                            <div className="quiz-empty-state">
                                                No quiz questions are available for this module right now.
                                            </div>
                                        )
                                    }
                                    {
                                        !isQuizReviewMode && Array.isArray(quiz.quizData) && quiz.quizData.length > 0 &&
                                            <button className="btn btn-primary mt-3 quiz-submit-btn" disabled={!canSubmitQuiz} onClick={() => { submitQuiz() }}>
                                                {quiz.isSubmitting ? "Submitting..." : "Submit"}
                                            </button>
                                    }
                                </div>) : (<div className="default-content-message">
                                    <p className="text-center">No content selected. Please click on content to preview.</p>
                                </div>)
                            }
                        </div>

                        <div className="col-4 module-wrapper m-3 p-0 activity-scroll">
                            {
                                activityInfo.activityName.toLocaleLowerCase() == "course" &&
                                <div className="d-flex justify-content-around  align-content-center module-start-end">
                                    <div className="d-flex flex-column ">
                                        <span ><ClockFill />&nbsp;&nbsp;Total Course Duration: </span>
                                        {/* <span>{activityInfo.details.courseCompletionTime}</span> */}
                                    </div>
                                    {/* <div className="mt-2">
                                        -------
                                    </div> */}
                                    <div className="d-flex flex-column ">
                                        <span>{activityInfo.details.courseCompletionTime}</span>
                                    </div>
                                </div>
                            }

                            {activityInfo.details &&
                                activityInfo.details.hasOwnProperty("videoDetails") &&
                                activityInfo.details.videoDetails ? (
                                <>
                                    <>
                                        <div div className="module my-2">
                                            <div className="module-name-wrapper">
                                                {Array.isArray(activityInfo.details.videoDetails) &&
                                                    activityInfo.details.videoDetails.length ? (
                                                    <>
                                                        <p className="mb-0 d-flex justify-content-between" >Video</p>
                                                        <p className="mb-0">
                                                            <ContentMenu />&nbsp;{activityInfo.details.videoDetails.length} Content
                                                        </p>
                                                    </>
                                                ) : (
                                                    <p className="mb-0">No content available</p>
                                                )}
                                            </div>
                                        </div>
                                        {Array.isArray(activityInfo.details.videoDetails)
                                            ? activityInfo.details.videoDetails.map((video, index) => (
                                                <div
                                                    className="module-content-wrapper d-flex justify-content-center my-2"
                                                    onClick={() => {
                                                        let historyDetails = activityInfo.activityHistory.contentDetails && activityInfo.activityHistory.contentDetails.find(x => x.videoId == video.videoId)
                                                        checkLockedContent(video, index, activityInfo.activityName) &&
                                                            selectVideo(index, undefined, historyDetails?.mappingId, video.videoId, activityInfo.activityHistory.activityHistoryId, video.videoName)
                                                    }}
                                                    key={index}
                                                >
                                                    <div className={`content ${disabledItems(video.videoId, index)}`} title={removeSpecialCharacters(video.videoName).cleanFileName}>
                                                        {/* {index+1}.&nbsp;&nbsp; */}
                                                        {removeSpecialCharacters(video.videoName).icon}&nbsp;{removeSpecialCharacters(video.videoName, 33).cleanFileName}
                                                        <span className="float-end">
                                                            {activityInfo.activityHistory?.contentDetails?.some(details => {
                                                                return details.videoId === video.videoId && details.completionStatus;
                                                            }) && <Completed />}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))
                                            : null}
                                    </>
                                </>
                            ) : activityInfo.details &&
                            activityInfo.details.hasOwnProperty("modules") &&
                            activityInfo.details.modules.sort((a, b) => a.orderNumber - b.orderNumber).map((module, moduleIndex) => (
                                <>
                                    <div className="my-2 pointer" key={module.id}>
                                        <div className="module-name-wrapper" onClick={() => {
                                            // Incase want to lock module in  Future 

                                            // const uniqueModuleIds = new Set(activityInfo.playList.map(item => item.moduleId));
                                            // const uniqueModuleIdsArray = [...uniqueModuleIds];
                                            // const currentIndex = uniqueModuleIdsArray.indexOf(module.id);
                                            // const prevModuleId = currentIndex > 0 ? uniqueModuleIdsArray[currentIndex - 1] : null;
                                            // const lastItemWithModuleId = activityInfo.playList.find(item => item.moduleId === prevModuleId);

                                            // if (currentIndex === 0 || (prevModuleId && (lastItemWithModuleId.IsCompleted || activityInfo.activityHistory.contentDetails.some(x => x.moduleId === prevModuleId && x.moduleCompletionStatus)))) {
                                            handleModuleChange(module.id);
                                            // }

                                        }}>
                                            <p className="mb-0 d-flex justify-content-between" title={removeSpecialCharacters(module.name).cleanFileName}>
                                                <span>{module.orderNumber}.&nbsp;&nbsp;{removeSpecialCharacters(module.name, 33).cleanFileName}</span>
                                                {
                                                    activityInfo.activeModuleId == module.id ? <span><UpArrow /></span> : <span><Chevron /></span>
                                                }
                                            </p>
                                            {Array.isArray(module.moduleContent) &&
                                                module.moduleContent.length ? (
                                                <>
                                                    <div className="col-12 d-flex ">
                                                    <p className="mb-0 course-detail-module-con">
                                                        <ContentMenu />&nbsp;{module.moduleContent.length} Content
                                                    </p>
                                                    <p className="mb-0 course-detail-module-dur">~{module.moduleTime}</p>
                                                    </div>
                                                </>
                                            ) : (
                                                <p className="mb-0">No content available</p>
                                            )}
                                        </div>
                                        {activityInfo.activeModuleId == module.id && module.moduleContent.sort((a, b) => a.orderNumber - b.orderNumber).map((content, contentAttachmentIndex) => {
                                            return content.contentAttachment.sort((a, b) => a.orderNumber - b.orderNumber).map((attachment) => (
                                                <div className="module-content-wrapper d-flex justify-content-center my-2"
                                                    onClick={() => {
                                                        checkLockedContent(attachment, contentAttachmentIndex, activityInfo.activityName) &&
                                                            selectVideo(attachment.orderNumber, module.id, undefined, undefined, activityInfo.activityHistory.activityHistoryId, attachment.name)
                                                    }}
                                                    key={attachment.orderNumber}
                                                >
                                                    <div className={`content ${disabledItems(attachment.id, contentAttachmentIndex, module.id, moduleIndex)}`} title={removeSpecialCharacters(attachment.name).cleanFileName}>
                                                        {removeSpecialCharacters(attachment.name).icon}&nbsp;{removeSpecialCharacters(attachment.name, 30).cleanFileName}
                                                        <span className="float-end">
                                                            {activityInfo.activityHistory.contentDetails && activityInfo.activityHistory.contentDetails.some(details => {
                                                                return details.moduleInfo?.some(info => info.contentId == attachment.id && info.completionStatus);
                                                            }) && <Completed />}
                                                        </span>
                                                    </div>
                                                </div>
                                            ));

                                        })}
                                    </div >
                                </>
                            ))}
                            {
                                activityInfo.details.assignments && activityInfo.details.assignments.map((assignment) => (
                                    <div className="my-2 pointer" key={assignment.id}>
                                        <div className="module-name-wrapper" onClick={() => {
                                            handleModuleChange(assignment.id);
                                        }}>
                                            <p className="mb-0 d-flex justify-content-between ">
                                                <span title={removeSpecialCharacters(assignment.title).cleanFileName}>{removeSpecialCharacters(assignment.title, 40).cleanFileName}</span>{
                                                    activityInfo.activeModuleId == module.id ? <span><UpArrow /></span> : <span><Chevron /></span>
                                                }
                                            </p>
                                            <p>{assignment.assignmentAttachment.length}&nbsp;Assignment</p>
                                        </div>
                                        {activityInfo.activeModuleId === assignment.id && activityInfo.details.assignments.map((content, contentAttachmentIndex) => {
                                            return content.assignmentAttachment.map((attachment) => (
                                                <div key={content.id} className="module-content-wrapper d-flex justify-content-center my-2">
                                                    <div className="content" onClick={() => {
                                                        handleAssignmentClick(contentAttachmentIndex) &&
                                                            selectAssignment("assignment")
                                                    }} title={attachment.name}>
                                                        <p className="mb-0 "><span className="assignment-icon">{removeSpecialCharacters(attachment.name).icon}</span>&nbsp;&nbsp;{removeSpecialCharacters(attachment.name, 33).cleanFileName} <span className="float-end">{attachment.isCompleted && <Completed />}</span> </p>
                                                    </div>
                                                </div>
                                            ));
                                        })}
                                    </div>
                                ))
                            }
                        </div>
                    </div >
                </div >}

            <ReactModal size="lg" dialogClassName="modal-90w" centered show={isReadMoreModal.showModal}
                onHide={() => setIsReadMoreModal((prevState) => ({
                    ...prevState,
                    showModal: false
                }))}>
                <ReactModal.Header
                    closeButton
                    style={{
                        borderBottom: "0.063rem solid var(--bs-modal-header-border-color)",
                    }}
                >
                    <ReactModal.Title className="h6 fw-bold">{activityInfo.activityName} Info</ReactModal.Title>
                </ReactModal.Header>
                <ReactModal.Body>
                    <p>
                        <span className="fw-bold">Title :</span> <span className="opacity-75 overflow-hidden text-break">{isReadMoreModal.selectedItems && isReadMoreModal.selectedItems.title}</span>
                    </p>

                    <Form.Group>
                        <Form.Label>
                            <span className="fw-bold">Description : </span>
                        </Form.Label>
                        <Form.Control className="opacity-75" disabled as="textarea" style={{ fontSize: "0.813rem" }} defaultValue={isReadMoreModal.selectedItems && isReadMoreModal.selectedItems.description} rows={4} cols={60}></Form.Control>
                    </Form.Group>
                </ReactModal.Body>
            </ReactModal>
        </>
    );
};

export default ActivityDetailedView;
